<template>
  <div class="flex justify-between items-center px-4 sm:px-0">
    <h1 class="text-xl font-bold truncate">
      {{
        translate(
          `site.library.status.tab.${tryConvertToReadingStatus(current)}`,
        )
      }}
    </h1>
    <!--    <Tabs class="mb-4" v-model="current" :tabs="paths" />-->
    <ContextMenuList
      :options="
        paths.map((path) => ({
          name: path.name,
          href: path.href,
          action: () => (statusButtonText = path.value),
        }))
      "
    >
      <template v-slot="{ isOpen, open, close }">
        <NamiButton
          button-type="secondary"
          @button-click="() => (isOpen ? close() : open())"
        >
          {{
            statusButtonText
              ? translate(
                  `site.library.status.tab.${tryConvertToReadingStatus(current)}`,
                )
              : "Reading Status"
          }}
          <IconChevronDown />
        </NamiButton>
      </template>
    </ContextMenuList>
  </div>
  <NuxtPage />
</template>

<script setup lang="ts">
import { IconChevronDown } from "@tabler/icons-vue";
import { ALL_READING_STATUSES, type TitleReadingStatus } from "~/src/api";

const nuxtApp = useNuxtApp();
const { locale, t: translate } = useI18n();
const mappedLocale = computed(() => reverseLocaleMap(locale.value));

const tryConvertToReadingStatus = (
  status: string,
): TitleReadingStatus | false => {
  if (status === "planned") return "plan_to_read";
  if (status === "hold") return "on_hold";
  if (!ALL_READING_STATUSES.includes(status as TitleReadingStatus))
    return false;
  return status as TitleReadingStatus;
};

const statusButtonText = ref("");

const { current, paths } = useSubpaths(
  computed(() => ({
    default: "reading",
    rootPath: `/${mappedLocale.value}/library/status`,
    paths: [
      { name: translate("site.library.status.tab.reading"), value: "reading" },
      {
        name: translate("site.library.status.tab.plan_to_read"),
        value: "planned",
      },
      { name: translate("site.library.status.tab.on_hold"), value: "hold" },
      {
        name: translate("site.library.status.tab.completed"),
        value: "completed",
      },
      { name: translate("site.library.status.tab.dropped"), value: "dropped" },
    ],
  })),
);
</script>
